
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import anime from "animejs";
import ScrollAnimatedTitle from "@/components/ScrollAnimatedTitle.vue";

@Component({ components: { ScrollAnimatedTitle } })
export default class Partners extends Vue {
  @Prop({ required: true, type: Number })
  private progress!: number;
  private animations: anime.AnimeInstance[] = [];
  get maxAnimationDuration() {
    return this.animations.reduce((max, c) => Math.max(max, c.duration), 0);
  }

  get images() {
    // PNGs, not the supplied SVGs: those wrap raster art in a SQUARE canvas
    // with big transparent margins (e.g. a 320x98 wordmark centred in 400x400),
    // so object-fit: contain rendered the actual mark at a fraction of the
    // cell. These are the same images tightly trimmed, so they fill the cell.
    const path = require.context("@/assets/logos", false, /\.png$/);
    // Sorted so the reveal order is alphabetical regardless of context order.
    // Netflix replaces BP in its former third slot in the top row.
    const sortKey = (key: string) =>
      key === "./netflix.png" ? "./bp.png" : key;
    return path
      .keys()
      .filter(
        (key) =>
          ![
            "./bp.png",
            "./ena.png",
            "./mccoll-s.png",
            "./simply-cook.png",
          ].includes(key)
      )
      .sort((a, b) => sortKey(a).localeCompare(sortKey(b)))
      .map(path);
  }

  private mounted() {
    // Staggered scale-in; anime derives the total duration from the last item's
    // delay, so this scales to any number of logos automatically.
    this.animations = [
      anime({
        targets: ["#slide-partners .brand"],
        scale: [0, 1],
        duration: 700,
        delay: (el, i) => i * 200,
        autoplay: false,
      }),
    ];
  }

  @Watch("progress")
  private onProgressChange(val: number) {
    this.animations.forEach((a) => a.seek(val * this.maxAnimationDuration));
  }
}

/*
  PARTNERS VIDEO LOGIC — restore alongside the <video> block in the template.

  import { Component, Vue, Prop, Watch, Ref } from "vue-property-decorator";

  @Ref() private readonly video!: HTMLVideoElement;
  private videoReady = false;
  private videoPlayed = false;

  // in mounted():
  this.video.load();
  this.video.onloadedmetadata = () => (this.videoReady = true);

  // in onProgressChange(val):
  if (val > 0 && this.videoReady && !this.videoPlayed) {
    this.video.play();
    this.videoPlayed = true;
  }
*/
